<template>
  <div id="app-content" class="container-fluid">
    <div id="nav" v-if="!$route.meta.hideNavbar">
			<nav class="navbar navbar-expand-lg navbar-dark bg-primary">
				<a class="navbar-brand" href="#"><img src="./assets/logo.png" class="img-fluid" style="max-height: 45px"></a>
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>
				<div class="collapse navbar-collapse" id="navbarNav">
					<ul class="navbar-nav">
						<li class="nav-item">
							<router-link to="/" class="nav-link" data-toggle="collapse" data-target=".navbar-collapse.show">
								<span aria-hidden="true">
									<svg class="feather">
										<use xlink:href="./assets/feather-sprite.svg#home"/>
									</svg>
								</span>
								Home
							</router-link>
						</li>
						<li class="nav-item">
							<router-link to="/action" class="nav-link" data-toggle="collapse" data-target=".navbar-collapse.show">
								<span aria-hidden="true">
									<svg class="feather">
										<use xlink:href="./assets/feather-sprite.svg#alert-triangle"/>
									</svg>
								</span>
								Action
							</router-link>
						</li>
						<li class="nav-item">
							<router-link to="/dispatch" class="nav-link" data-toggle="collapse" data-target=".navbar-collapse.show">
								<span aria-hidden="true">
									<svg class="feather">
										<use xlink:href="./assets/feather-sprite.svg#package"/>
									</svg>
								</span>
								Dispatch
							</router-link>
						</li>
						<li class="nav-item">
							<router-link to="/delivery-notes" class="nav-link" data-toggle="collapse" data-target=".navbar-collapse.show">
								<span aria-hidden="true">
									<svg class="feather">
										<use xlink:href="./assets/feather-sprite.svg#truck"/>
									</svg>
								</span>
								Delivery notes
							</router-link>
						</li>
						<li class="nav-item">
							<router-link to="/invoices" class="nav-link" data-toggle="collapse" data-target=".navbar-collapse.show">
								<span aria-hidden="true">
									<svg class="feather">
										<use xlink:href="./assets/feather-sprite.svg#list"/>
									</svg>
								</span>
								Invoices
							</router-link>
						</li>
						<li class="nav-item">
							<router-link to="/ordering" class="nav-link" data-toggle="collapse" data-target=".navbar-collapse.show">
								<span aria-hidden="true">
									<svg class="feather">
										<use xlink:href="./assets/feather-sprite.svg#shopping-cart"/>
									</svg>
								</span>
								Ordering
							</router-link>
						</li>
						<li class="nav-item">
							<router-link to="/print" class="nav-link" data-toggle="collapse" data-target=".navbar-collapse.show">
								<span aria-hidden="true">
									<svg class="feather">
										<use xlink:href="./assets/feather-sprite.svg#printer"/>
									</svg>
								</span>
								Print
							</router-link>
						</li>
						<li class="nav-item">
							<router-link to="/progress" class="nav-link" data-toggle="collapse" data-target=".navbar-collapse.show">
								<span aria-hidden="true">
									<svg class="feather">
										<use xlink:href="./assets/feather-sprite.svg#trending-up"/>
									</svg>
								</span>
								Progress
							</router-link>
						</li>
						<li class="nav-item">
							<router-link to="/search" class="nav-link" data-toggle="collapse" data-target=".navbar-collapse.show">
								<span aria-hidden="true">
									<svg class="feather">
										<use xlink:href="./assets/feather-sprite.svg#search"/>
									</svg>
								</span>
								Search
							</router-link>
						</li>
						<li class="nav-item dropdown">
							<a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<span aria-hidden="true">
									<svg class="feather">
										<use xlink:href="./assets/feather-sprite.svg#more-vertical"/>
									</svg>
								</span>
								Misc
							</a>
							<div class="dropdown-menu" aria-labelledby="navbarDropdown">
								<router-link to="/contacts" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#users"/>
										</svg>
									</span>
									Contacts
								</router-link>
								<router-link to="/special-discounts" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#percent"/>
										</svg>
									</span>
									Special discounts
								</router-link>
								<router-link to="/cx-reports" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#file-text"/>
										</svg>
									</span>
									CX reports
								</router-link>
								<router-link to="/bulk-print" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#printer"/>
										</svg>
									</span>
									Bulk print
								</router-link>
								<router-link to="/dx" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#dollar-sign"/>
										</svg>
									</span>
									DX charges
								</router-link>
								<router-link to="/postage" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#dollar-sign"/>
										</svg>
									</span>
									Postage charges WIP
								</router-link>
								<router-link to="/faxes" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#printer"/>
										</svg>
									</span>
									Faxes
								</router-link>
								<!--<router-link to="/lens-search" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									Lens search WIP
								</router-link>-->
								<router-link to="/pickups" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#archive"/>
										</svg>
									</span>
									Pickups
								</router-link>
								<router-link to="/quotes" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#clipboard"/>
										</svg>
									</span>
									Quotes
								</router-link>
								<!--<router-link to="/returns" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#corner-down-left"/>
										</svg>
									</span>
									Returns WIP
								</router-link>
								<router-link to="/lab-reports" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#pie-chart"/>
										</svg>
									</span>
									Lab reports WIP
								</router-link>-->
								<router-link to="/delivery-services" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#truck"/>
										</svg>
									</span>
									Delivery services
								</router-link>
								<router-link to="/product-update" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#refresh-cw"/>
										</svg>
									</span>
									Update products
								</router-link>
								<router-link to="/new-product" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#plus-square"/>
										</svg>
									</span>
									New product
								</router-link>
								<router-link to="/backup-restore" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#database"/>
										</svg>
									</span>
									Backup & restore
								</router-link>
								<router-link to="/flightboard" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#send"/>
										</svg>
									</span>
									Flightboard
								</router-link>
								<router-link to="/update-tracking" class="dropdown-item" data-toggle="collapse" data-target=".navbar-collapse.show">
									<span aria-hidden="true">
										<svg class="feather">
											<use xlink:href="./assets/feather-sprite.svg#compass"/>
										</svg>
									</span>
									Update tracking
								</router-link>
							</div>
						</li>
					</ul>
				</div>
			</nav>
    </div>
    <!-- adding :key to ExpressBanner forces it to reload the component upon path change, showing newly added or removed express job numbers -->
    <ExpressBanner v-if="!$route.meta.hideNavbar" :key="$route.fullPath"/>
    <router-view class="vh-100"/> <!-- vh-100 for flightboard -->
  </div>
</template>

<script>
import ExpressBanner from './components/ExpressBanner.vue'

export default {
	components: { ExpressBanner }
}
</script>

<style>
@page {
	margin: 0;
	padding: 0;
}
#app-content {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
.feather {
	width: 24px;
	height: 24px;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
	fill: none;
}
.feather-large {
	width: 36px;
	height: 36px;
	stroke: currentColor;
	stroke-width: 3;
	stroke-linecap: round;
	stroke-linejoin: round;
	fill: none;
}
.feather-filled {
	width: 24px;
	height: 24px;
	stroke: currentColor;
	stroke-width: 2;
	stroke-linecap: round;
	stroke-linejoin: round;
	fill: currentColor;
}
.fade-enter-active, .fade-leave-active {
	transition: all 0.5s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}
.list-enter-active, .list-leave-active {
	transition: all 0.5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
	opacity: 0;
}
hr.heavy {
	border-top: 1px solid #333;
}
.pre-formatted {
	white-space: pre-wrap;
}
.border-3 {
	border-style: solid;
	border-width: 3px !important;
}
@keyframes live-pulse {
	0%   { color: #0cf; }
	50%  { color: transparent; }
	100% { color: #0cf; }
}
    
@keyframes live-alert {
	0%   { color: #F00; }
	50%  { color: transparent; }
	100% { color: #F00; }
}
</style>
